/*=========================================================================================
  File Name: module-outinvoice-getters.js
  Description: OutInvoice Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	getOutInvoices(state) {
		return state.OutInvoices;
	},
	getOutInvoicesTotal(state) {
		return state.OutInvoicesTotal;
	},
	IsLoadingTotalRecords(state) {
		return state.IsLoadingTotalRecords;
	}
};
